module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAM0AAABAAgMAAADE/Bv8AAAADFBMVEXKIhSoTirOIRTAPiSTOFbOAAAABHRSTlMB/xWhI9NAeAAAATVJREFUSMe91jFqw0AQBdAfGYNjozL9EEiRQEr1PoILRwYRdABXKUOqRRAQDi7dC4NBbJ8+l9AlfIoklie1/zfx9o8/uzsrDZ74NYWEOh594eGTJIsIjD9I9NrgZ3Vscb8r46o7GKQUeu7RFYVmPRpQ6KVHIG+2Xx1/eLANg45BuBFQkvHXBOwIlDu6E1AyJNDck4Z8FwFrAY1SJSn99/LsnCQKBQWNBFR6eY8MkpJMaKMyBD4pl5K2dqmklXB6eW3KnqSkSrhcJalsg4IuV159RtI1g6LxqPCkewa1W/73XrQQ0MqUpIofJN4iBOTPfUwh/38SaOmImXOWrfFzzr4+vqeEmHP2je+JmHPire/p9IF5EZtAjyy5vwzgnUAV6FdY+McImBCt93cQEBoClp18eIeG+AZMz97SDiQm7gAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/pagess/gdd103/black.png
// module id = CkAu
// module chunks = 1